import React from "react";
import FeatherIcon from "feather-icons-react";
import { useEffect } from "react";
import { getCurrentUser } from "../firebase/authService";
import { useNavigate } from "react-router-dom";

const ImageUpload = ({ id, src, loadFile, imageName }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!getCurrentUser()) {
      navigate('/login');
    }
  
    
  }, [])
  
  const handleFileChange = (event) => {
    loadFile(event, id); // Pass the id to the loadFile function
  };

  return (
    <div className="col-12 col-md-6">
      <div className="form-group">
        <div
          className="upload-files-avator"
          style={{ 
            position: 'relative',
            border: '2px dashed #ddd',
            borderRadius: '8px',
            padding: '20px',
            textAlign: 'center',
            backgroundColor: '#fafafa',
            minHeight: '200px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {/* Display the uploaded image */}
          {src && (
            <div className="uploaded-image" style={{ position: 'relative', display: 'inline-block' }}>
              <img
                src={src}
                alt="Uploaded Image"
                style={{
                  width: '200px',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  border: '1px solid #ddd'
                }}
              />
              <div className="edit-icon" style={{ 
                position: 'absolute', 
                backgroundColor: '#007bff', 
                borderRadius: '50%',
                padding: '8px',
                right: '10px', 
                bottom: '10px',
                color: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
              }}>
                {/* Input for choosing a new image */}
                <input
                  type="file"
                  accept="image/*"
                  name={`image-${id}`} // Use id to create unique input name
                  id={`file-${id}`} // Use id to create unique input id
                  onChange={handleFileChange}
                  className="hide-input"
                  style={{ display: 'none' }}
                />
                <label htmlFor={`file-${id}`} className="upload" style={{ cursor: 'pointer', margin: 0, display: 'block' }}>
                  <FeatherIcon icon="edit" size={16} />
                </label>
              </div>
              <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                Click the edit icon to change image
              </p>
            </div>
          )}
          {/* Input for choosing a new image */}
          {!src && (
            <div style={{ textAlign: 'center' }}>
              <FeatherIcon icon="upload-cloud" size={48} style={{ color: '#ccc', marginBottom: '10px' }} />
              <p style={{ color: '#666', marginBottom: '15px' }}>Click to upload an image</p>
              <input
                type="file"
                accept="image/*"
                name={`image-${id}`} // Use id to create unique input name
                id={`file-${id}`} // Use id to create unique input id
                onChange={handleFileChange}
                style={{ display: 'none' }}
                placeholder="Select an Image..."
              />
              <label htmlFor={`file-${id}`} style={{ 
                cursor: 'pointer',
                backgroundColor: '#007bff',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '4px',
                border: 'none',
                display: 'inline-block'
              }}>
                Choose File
              </label>
              <p style={{ fontSize: '12px', color: '#999', marginTop: '10px' }}>
                Supported formats: JPG, PNG, GIF
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageUpload;
